import {getDeviceType} from "../../library/device-type";
import {addOverlay, removeOverlay} from "../../library/overlay";
import {ga4TrackSimpleEvent} from "../../website/webpack/modules/analytics";
import {onVisible} from "../../website/scripts/Tools/visible-element-observer";
import {windowScrollEvent} from "../../website/webpack/modules/events";

onVisible(document.querySelectorAll("#left-menu-country-selector img"), (image) => image.src = image.dataset.src);

$(document).ready(function() {
    replaceCountryLinks();
    loadAutoloadMenus();
});

$('.open-left-menu').click(function() {
    let leftMenu = $("#left-menu.left-menu-v2");
    if ($('.left-menu-v2').hasClass('open')) {
        $('.left-menu-v2').removeClass('open');
        $('.left-menu-v2:not(.left-menu-main-level) nav.show').removeClass('show');
        removeOverlay();
        ga4TrackSimpleEvent({event: 'header_menu', method: 'close'});
    } else {
        openLeftMenu(leftMenu);
        addOverlay();
        $('.overlay').height(leftMenu.height()).css('top', 'inherit').css('bottom', '0');
        ga4TrackSimpleEvent({event: 'header_menu', method: 'open'});
    }
});

$(document).on('click', '.overlay, .left-menu-v2 .close-left-menu', function() {
    let leftMenu = $(".left-menu-v2");
    if (leftMenu && leftMenu.hasClass('open')) {
        closeLeftMenu(leftMenu);
        $('.left-menu-v2:not(.left-menu-main-level) nav.show').removeClass('show');
        removeOverlay();
        ga4TrackSimpleEvent({event: 'header_menu', method: 'close'});
        clearTimeout(openLeftMenuTimeout);
    }
});

let backdropHoverTimeout;
let openLeftMenuTimeout;
$(document).on('mouseenter', '.overlay', function() {
    if (getDeviceType() !== 'desktop') return;
    if (!$('.left-menu-v2.open').length) return;
    if (backdropHoverTimeout) clearTimeout(backdropHoverTimeout);
    backdropHoverTimeout = setTimeout(function() {
        $('.left-menu-v2.open').removeClass('open');
        $('.left-menu-v2:not(.left-menu-main-level) nav.show').removeClass('show');
        removeOverlay();
        ga4TrackSimpleEvent({event: 'header_menu', method: 'close'});
    }, 300);
});

$(document).on('click', '.open-country-selector', openCountrySelector);
$(document).on('click', '.close-country-selector', closeCountrySelector);

$('.left-menu-v2').on('mouseenter', function() {
    if (getDeviceType() !== 'desktop') return;
    if (backdropHoverTimeout) clearTimeout(backdropHoverTimeout);
    if (openLeftMenuTimeout) clearTimeout(openLeftMenuTimeout);
});

$(document).on('click', '.left-menu-v2 .open-menu', function() {
    openMenu($(this));
});

$(document).on('click', '.left-menu-v2 .go-back-menu', function() {
    let currentLeftMenu = $(this).closest('.left-menu-v2');
    let currentNav = currentLeftMenu.find('nav.show');
    let previousNav = $(`.left-menu-v2 .open-menu[data-next-menu="${currentNav.data('id')}"]`).closest('nav');
    let previousLeftMenu = previousNav.closest('.left-menu-v2');

    currentNav.removeClass('show');
    previousNav.addClass('show');
    closeLeftMenu(currentLeftMenu)
    openLeftMenu(previousLeftMenu);
    ga4TrackSimpleEvent({event: 'header_menu', method: 'back'});
});

$("#left-menu-open-country-selector").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(this).hasClass('open-country-selector')) {
        $(this).removeClass('open-country-selector').addClass('close-country-selector');
        openCountrySelector();
    } else if ($(this).hasClass('close-country-selector')) {
        $(this).removeClass('close-country-selector').addClass('open-country-selector');
        closeCountrySelector();
    }
});

$(document).on('mouseenter', '.left-menu-v2 .open-menu', function() {
    if (getDeviceType() !== 'desktop') return;
    let button = $(this);
    if (openLeftMenuTimeout) clearTimeout(openLeftMenuTimeout);
    openLeftMenuTimeout = setTimeout(function() {
        openMenu(button);
    }, 300);
});

$(document).on('mouseenter', '.left-menu-v2 .link', function() {
    if (getDeviceType() !== 'desktop') return;
    let leftMenu = $(this).closest('.left-menu-v2');
    let secondLevelLeftMenu = $('.left-menu-v2.left-menu-second-level.open');
    let thirdLevelLeftMenu = $('.left-menu-v2.left-menu-third-level.open');

    if (leftMenu.hasClass('left-menu-main-level')) {
        if (secondLevelLeftMenu) {
            closeLeftMenu(secondLevelLeftMenu);
            secondLevelLeftMenu.find('nav.show').removeClass('show');
        }
        if (thirdLevelLeftMenu) {
            closeLeftMenu(thirdLevelLeftMenu);
            thirdLevelLeftMenu.find('nav.show').removeClass('show');
        }
    } else if (leftMenu.hasClass('left-menu-second-level')) {
        if (thirdLevelLeftMenu) {
            closeLeftMenu(thirdLevelLeftMenu);
            thirdLevelLeftMenu.find('nav.show').removeClass('show');
        }
    }
});

$(document).on('mouseenter', '.left-menu-v2 .text-item', function() {
    if (getDeviceType() !== 'desktop') return;
    let leftMenu = $(this).closest('.left-menu-v2');
    let secondLevelLeftMenu = $('.left-menu-v2.left-menu-second-level.open');
    let thirdLevelLeftMenu = $('.left-menu-v2.left-menu-third-level.open');

    if (leftMenu.hasClass('left-menu-main-level')) {
        if (secondLevelLeftMenu) {
            closeLeftMenu(secondLevelLeftMenu);
            secondLevelLeftMenu.find('nav.show').removeClass('show');
        }
        if (thirdLevelLeftMenu) {
            closeLeftMenu(thirdLevelLeftMenu);
            thirdLevelLeftMenu.find('nav.show').removeClass('show');
        }
    } else if (leftMenu.hasClass('left-menu-second-level')) {
        if (thirdLevelLeftMenu) {
            closeLeftMenu(thirdLevelLeftMenu);
            thirdLevelLeftMenu.find('nav.show').removeClass('show');
        }
    }
});

$(document).on('click', '.outer-menu-open', function() {
    let leftMenu = $(".left-menu-v2");
    if (leftMenu && leftMenu.hasClass('open')) {
        closeLeftMenu(leftMenu);
        $('.left-menu-v2:not(.left-menu-main-level) nav.show').removeClass('show');
        removeOverlay();
        ga4TrackSimpleEvent({event: 'header_menu', method: 'close'});
    }
});

$(document).on('mouseenter', '#hmtSearch #desktopSearchInput, #hmtLogin button, #hmtCart, #header-messages', function() {
    let leftMenu = $(".left-menu-v2");
    if (leftMenu && leftMenu.hasClass('open')) {
        closeLeftMenu(leftMenu);
        $('.left-menu-v2:not(.left-menu-main-level) nav.show').removeClass('show');
        removeOverlay();
        ga4TrackSimpleEvent({event: 'header_menu', method: 'close'});
    }
});

function openLeftMenu(leftMenu)
{
    if (!leftMenu || leftMenu.length === 0) return;
    if (leftMenu.hasClass('open')) return;

    let headerMessages = document.querySelector('#header-messages');
    if (!headerMessages) return;
    let rect = headerMessages.getBoundingClientRect();
    let headerMessagesVisible = rect.top < window.innerHeight && rect.bottom > 0;

    if (getDeviceType() === 'desktop') {
        if (headerMessagesVisible) calculateLeftMenuHeight();
        else calculateLeftMenuHeightWithoutMessages();
    }
    leftMenu.addClass('open');
}

function closeLeftMenu(leftMenu)
{
    if (!leftMenu || leftMenu.length === 0) return;
    if (!leftMenu.hasClass('open')) return;
    leftMenu.removeClass('open');
}

function openCountrySelector()
{
    let countrySelector = $("#left-menu-country-selector");
    if (!countrySelector) return;
    countrySelector.slideDown();
    ga4TrackSimpleEvent({event: 'header_country_selector', method: 'open'});
}

function closeCountrySelector()
{
    let countrySelector = $("#left-menu-country-selector");
    if (!countrySelector) return;
    countrySelector.slideUp();
    if ($("#left-menu-open-country-selector").hasClass('close-country-selector')) $("#left-menu-open-country-selector").removeClass('close-country-selector').addClass('open-country-selector');
    ga4TrackSimpleEvent({event: 'header_country_selector', method: 'close'});
}

function replaceCountryLinks()
{
    let alternates = document.querySelectorAll('link[rel=alternate]');
    alternates.forEach(function(alternate) {
        let hreflang = alternate.getAttribute('hreflang');
        let locale = hreflang.replace("-","_");
        let href = alternate.getAttribute('href');
        let link = document.querySelector(`.selector-website[data-locale=${locale}]`);
        if (link) link.setAttribute("href", href);
    });
}

function openMenu(button)
{
    let menuId = button.data('nextMenu');
    let currentLeftMenu = button.closest('.left-menu-v2');
    let isDynamic = currentLeftMenu.hasClass('left-menu-dynamic');
    let nextLeftMenu = null;

    if (currentLeftMenu.hasClass('left-menu-main-level')) nextLeftMenu = $('.left-menu-v2.left-menu-second-level');
    if (currentLeftMenu.hasClass('left-menu-second-level')) nextLeftMenu = $('.left-menu-v2.left-menu-third-level');

    if (!nextLeftMenu || nextLeftMenu.length === 0) return;
    if (nextLeftMenu.find(`nav[data-id="${menuId}"].show`).length > 0) return;

    if (nextLeftMenu.hasClass('left-menu-second-level') && getDeviceType() === 'desktop') {
        $('.left-menu-v2.left-menu-third-level.open').removeClass('open');
        $('.left-menu-v2.left-menu-third-level nav.show').removeClass('show');
    }

    if (isDynamic) {
        showLoader(nextLeftMenu);
        openLeftMenu(nextLeftMenu);
        nextLeftMenu.find('.body .container-fluid').html('');
        nextLeftMenu.find('span.title').html('');
        getMenuHtmlById(menuId, function(html) {
            if (!html) return;
            hideLoader(nextLeftMenu);
            nextLeftMenu.find('.body .container-fluid').html(html);

            let nav = nextLeftMenu.find(`nav[data-id="${menuId}"]`);
            let title = nav.data('title');

            nextLeftMenu.find('span.title').html(title);
            nav.addClass('show');
            ga4TrackSimpleEvent(
                {
                    event: 'header_menu',
                    method: 'navigate',
                    link_id: currentLeftMenu.hasClass('left-menu-main-level') ? 'from-main' : 'from-submenu',
                    link_text: title.toLowerCase()
                }
            );
        });
    } else {
        let nav = $(`.left-menu-v2 nav[data-id="${menuId}"]`);
        let title = nav.data('title');

        if (nav.hasClass('show')) return;

        nextLeftMenu.find('nav.show').removeClass('show');
        nextLeftMenu.find('span.title').html(title);
        nav.addClass('show');

        if (getDeviceType() !== 'desktop') closeLeftMenu(currentLeftMenu);
        openLeftMenu(nextLeftMenu);
        ga4TrackSimpleEvent(
            {
                event: 'header_menu',
                method: 'navigate',
                link_id: currentLeftMenu.hasClass('left-menu-main-level') ? 'from-main' : 'from-submenu',
                link_text: title.toLowerCase()
            }
        );
    }
}

let ajaxGetMenuHtml = null;
function getMenuHtmlById(id, callback)
{
    if (ajaxGetMenuHtml) ajaxGetMenuHtml.abort();
    ajaxGetMenuHtml = $.ajax({
        url: '/ajax/left-menu/get-menu-html',
        type: 'POST',
        data: {id: id},
        success: function(data) {
            ajaxGetMenuHtml = null;
            callback(data.html);
        },
        error: function (data) {
            ajaxGetMenuHtml = null;
            callback(null);
        }
    });
}

function showLoader(leftMenu)
{
    leftMenu.find('.body').append('<div class="swiper-lazy-preloader loader"></div>');
}

function hideLoader(leftMenu)
{
    leftMenu.find('.body .loader').remove();
}

function loadAutoloadMenus()
{
    $('.left-menu-v2.autoload-left-menu').each(function() {
        let leftMenu = $(this);
        let menuIds = $(this).data('menuIds');
        if (!menuIds) return;
        $.ajax({
            url: '/ajax/left-menu/get-menus-html',
            type: 'POST',
            data: {ids: menuIds},
            success: function(data) {
                if (!data.html) return;
                leftMenu.find('.body .container-fluid').append(data.html);
            },
        });
    });
}

function calculateLeftMenuHeight()
{
    let headerHeight = $('header').height() + $('#header-messages').height();
    $('.left-menu-v2').height($(window).height() - headerHeight);
}

function calculateLeftMenuHeightWithoutMessages()
{
    console.log($('header').height());
    console.log($(window).height());
    let headerHeight = $('header').height();
    $('.left-menu-v2').height($(window).height() - headerHeight);
}